<div class="page-header-container">
  <div class="page-header-section">
    <div class="page-header-sub-title" *ngIf="subTitle">{{ subTitle }}</div>
    <div class="page-header-title">{{ title }}</div>
    <!-- <div class="content-items"> -->
      <ng-content></ng-content>
    <!-- </div> -->
  </div>
</div>
